import React, { useState } from 'react'
import DataTable from '@ublique/components/DataTable'
import HeaderComponent from './HeaderComponent'

import { defaultFieldTableConfigs } from './configs'
import 'pages/Administration/components/index.scss'
import { useAgGridTranslation } from 'utils/hooks/useDocumentTranslation'

const DetailsFieldTable = ({
  columnDefs,
  rowData,
  getRowNodeId,
  headerActions,
  onGridReady,
  onCellClicked,
  onCellValueChanged,
  onSelectionChanged,
  frameworkComponents,
  extraHeaderComponent,
  isRowMaster,
  masterDetail,
  selectedRows,
  detailCellRendererParams,
  onFirstDataRendered,
  onRowSelected,
  excelStyles,
  defaultExportParams,
  ...tableProps
}) => {
  const { t: agGridT, destroyed } = useAgGridTranslation()
  return (
    <div className='table-view'>
      <DataTable
        {...defaultFieldTableConfigs}
        {...tableProps}
        canSearch={false}
        columnDefs={columnDefs}
        rowData={rowData || []}
        getRowNodeId={getRowNodeId}
        isRowMaster={isRowMaster}
        masterDetail={masterDetail}
        detailCellRendererParams={detailCellRendererParams}
        onGridReady={onGridReady}
        onCellClicked={onCellClicked}
        onFirstDataRendered={onFirstDataRendered}
        onCellValueChanged={onCellValueChanged}
        onSelectionChanged={onSelectionChanged}
        onRowSelected={onRowSelected}
        frameworkComponents={frameworkComponents}
        excelStyles={excelStyles}
        defaultExportParams={defaultExportParams}
        localeTextFunc={agGridT}
        extraHeaderComponent={
          headerActions ? (
            <HeaderComponent
              actions={headerActions}
              selectedSize={selectedRows.length}
            />
          ) : (
            extraHeaderComponent
          )
        }
      />
    </div>
  )
}

DetailsFieldTable.defaultProps = {
  headerActions: null,
  onSelectionChanged: () => {}
}

export default React.memo(DetailsFieldTable)
